import P10001 from '../images/product/P10001.png'
import P20001 from '../images/product/P20001.png'
import P30001 from '../images/product/P30001.png'
import P30002 from '../images/product/P30002.png'
import P20002 from '../images/product/P20002.png'
import P10002 from '../images/product/P10002.png'
import P10003 from '../images/product/P10003.png'
import P30003 from '../images/product/P30003.png'
import P20003 from '../images/product/P20003.png'
import P20004 from '../images/product/P20004.png'
import P10004 from '../images/product/P10004.png'
import P30004 from '../images/product/P30004.png'
import P20005 from '../images/product/P20005.png'
import P20006 from '../images/product/P20006.png'
import P20007 from '../images/product/P20007.png'
import P30005 from '../images/product/P30005.png'
import P10005 from '../images/product/P10005.png'
import P30006 from '../images/product/P30006.png'
import P10006 from '../images/product/P10006.png'
import P20008 from '../images/product/P20008.png'
import P20009 from '../images/product/P20009.png'
import P20010 from '../images/product/P20010.png'
import P50001 from '../images/product/P50001.png'
import P10007 from '../images/product/P10007.png'
import P50002 from '../images/product/P50002.png'
import P10008 from '../images/product/P10008.png'
import P20011 from '../images/product/P20011.png'
import P40001 from '../images/product/P40001.png'
import P20012 from '../images/product/P20012.png'
import P20013 from '../images/product/P20013.png'
import P20014 from '../images/product/P20014.png'
import P40002 from '../images/product/P40002.png'
import P10009 from '../images/product/P10009.png'
import P10010 from '../images/product/P10010.png'
import P40003 from '../images/product/P40003.png'
import P10011 from '../images/product/P10011.png'
import P10012 from '../images/product/P10012.png'
import P10013 from '../images/product/P10013.png'
import P10014 from '../images/product/P10014.png'
import P10015 from '../images/product/P10015.png'
import P10016 from '../images/product/P10016.png'
import P10017 from '../images/product/P10017.png'
import P10018 from '../images/product/P10018.png'
import P10019 from '../images/product/P10019.png'
import P10020 from '../images/product/P10020.png'
import P10021 from '../images/product/P10021.png'
import P10022 from '../images/product/P10022.png'
import P20015 from '../images/product/P20015.png'
import P10023 from '../images/product/P10023.png'
import P10024 from '../images/product/P10024.png'
import P10025 from '../images/product/P10025.png'
import P30007 from '../images/product/P30007.png'
import P20016 from '../images/product/P20016.png'
import P20017 from '../images/product/P20017.png'
import P99999 from '../images/product/P99999.png'
import PDOC10001_1 from '../images/product/jiezhifa_1.png'
import PDOC10001_2 from '../images/product/jiezhifa_2.png'
import PDOC10001_3 from '../images/product/jiezhifa_3.png'
import ind1 from '../images/industry/ind1.jpg'
import ind2 from '../images/industry/ind2.jpg'
import ind3 from '../images/industry/ind3.jpg'
import ind4 from '../images/industry/ind4.jpg'
import ind5 from '../images/industry/ind5.jpg'
import ind6 from '../images/industry/ind6.jpg'
import ind7 from '../images/industry/ind7.jpg'
import ind8 from '../images/industry/ind8.jpg'
import ind9 from '../images/industry/ind9.jpg'

export const products = [
  {
    pid: 10001,
    name: 'KSD-J42W 槽罐车专用压力表截止阀',
    picture: P10001,
    slogan: '产品标语',
    feature: '法兰为非焊接式，锻造一体化，减少渗漏点，提高安全性',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
    document: [
      {
        type: 'image',
        src: PDOC10001_1,
      },
      {
        type: 'text',
        content:
          '总体来说这两个截止阀都是用作压力表取压管路上的，用于通断取压管路的作用。',
      },
      {
        type: 'text',
        content:
          '83101-00007这个阀作为总阀，装在罐体底部单独的凸缘上；该阀不仅可以通断取压管路在冬天还起到了排冷凝水的作用。',
      },
      {
        type: 'text',
        content:
          '83101-00011这个阀只起通断取压管路的作用，一般在更换压力表时将该阀门关闭，平时都是常开的。',
      },
      {
        type: 'image',
        src: PDOC10001_2,
      },
      {
        type: 'image',
        src: PDOC10001_3,
      },
    ],
  },
  {
    pid: 20001,
    name: 'Q41F 法兰式球阀',
    picture: P20001,
    slogan: '产品标语',
    feature: '全通径设计，流体阻力近乎为零',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 30001,
    name: 'H44 旋启式止回阀',
    picture: P30001,
    slogan: '产品标语',
    feature: '单瓣旋启结构，响应速度快',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 30002,
    name: 'D71X 对夹式蝶阀',
    picture: P30002,
    slogan: '产品标语',
    feature: '中线对称设计，双向密封性能一致',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 20002,
    name: 'Q11F 内螺纹带锁球阀',
    picture: P20002,
    slogan: '产品标语',
    feature: '一体式锻造阀体，承压能力强',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 10002,
    name: 'J26W T型 槽罐车专用压力表截止阀',
    picture: P10002,
    slogan: '产品标语',
    feature: '在传统三通截止阀的基础上，进行结构创新，彻底取代行业原先解决方案',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
    specialized: ['荆门宏图专用'],
  },
  {
    pid: 10003,
    name: 'KSD-J24W-25P L型 槽罐车专用角式截止阀',
    picture: P10003,
    slogan: '产品标语',
    feature:
      '在传统角式截止阀的基础上进行了优化，解决了槽车空间受限，影响操作的问题',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
    specialized: ['荆门宏图专用'],
  },
  {
    pid: 30003,
    name: 'KSD-J26W-T型 槽罐车专用测压阀',
    picture: P30003,
    slogan: '产品标语',
    feature:
      '在传统三通截止阀基础上进行结构创新，一端连接变送器，一端连接压力表，解决行业原先无法更换压力表的问题',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
    specialized: [
      '荆门宏图专用',
      '中集瑞江专用',
      '楚胜汽车专用',
      '中集系统专用',
    ],
  },
  {
    pid: 20003,
    name: 'Q91PK-320P 高压卡套球阀',
    picture: P20003,
    slogan: '产品标语',
    feature: '适用于各种高压气体管路',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 20004,
    name: 'Q21SA 仿美球阀',
    picture: P20004,
    slogan: '产品标语',
    feature: '手柄采用全304手柄，代替原先的塑胶手柄，在医药行业很受欢迎',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 10004,
    name: 'J41H 常规截止阀',
    picture: P10004,
    slogan: '产品标语',
    feature: '法兰连接，DN15-DN300全规格覆盖',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 30004,
    name: 'D341H 法兰式蝶阀',
    picture: P30004,
    slogan: '产品标语',
    feature: '适用于水蒸气、油类介质的切断使用',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 20005,
    name: 'Q611F 气动球阀',
    picture: P20005,
    slogan: '产品标语',
    feature: '双作用/单作用执行器可选',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 20006,
    name: 'SB02 手压泵专用球阀',
    picture: P20006,
    slogan: '产品标语',
    feature: '微型设计，重量不足200g',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 20007,
    name: 'QG Y1型 压力表球阀',
    picture: P20007,
    slogan: '产品标语',
    feature: '三通结构，带排污功能',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 30005,
    name: 'J123W-40P 压力表取样阀',
    picture: P30005,
    slogan: '产品标语',
    feature:
      '解决高寒环境下将压力表内腔内剩余介质排净问题，从而保护压力表，防止冻坏',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 10005,
    name: 'JJ6M4 角式压力表截止阀',
    picture: P10005,
    slogan: '产品标语',
    feature: '取代传统压力表截止阀，节约成本',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 30006,
    name: '槽罐车专用切断阀放散阀',
    picture: P30006,
    slogan: '产品标语',
    feature: '紧急情况下可迅速关闭，确保安全',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 10006,
    name: 'J24 角式截止阀',
    picture: P10006,
    slogan: '产品标语',
    feature: '优化管道布局，减少弯头需求',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
    specialized: ['荆门宏图专用'],
  },
  {
    pid: 20008,
    name: 'Q21F 外螺纹球阀',
    picture: P20008,
    slogan: '产品标语',
    feature: '安装便捷，兼容标准管道接口',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 20009,
    name: 'QGY1 带锁气源球阀',
    picture: P20009,
    slogan: '产品标语',
    feature: '可锁定开/关状态，防止误操作',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 20010,
    name: 'Q11F 锻钢内螺纹球阀',
    picture: P20010,
    slogan: '产品标语',
    feature: '高强度，耐高压和高温',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 50001,
    name: 'Y型过滤器',
    picture: P50001,
    slogan: '产品标语',
    feature: 'Y型结构增大过滤面积，杂质拦截率高',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 10007,
    name: 'J11 锻钢内螺纹截止阀',
    picture: P10007,
    slogan: '产品标语',
    feature: '耐高压（PN40以上），抗冲击',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 50002,
    name: 'SB02 手压油泵',
    picture: P50002,
    slogan: '产品标语',
    feature: '无需电力，适合无电源环境',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 10008,
    name: 'J62W 压力表截止阀',
    picture: P10008,
    slogan: '产品标语',
    feature: '直接连接压力表，方便监测',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 20011,
    name: 'Q61 承插焊球阀',
    picture: P20011,
    slogan: '产品标语',
    feature: '焊接牢固，无泄漏风险',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 40001,
    name: '法兰式三阀组',
    picture: P40001,
    slogan: '产品标语',
    feature: '集成平衡阀、高压阀和低压阀，简化管路',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 20012,
    name: '食品行业三片式球阀',
    picture: P20012,
    slogan: '产品标语',
    feature: '内壁抛光，符合FDA标准',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 20013,
    name: '三片式球阀',
    picture: P20013,
    slogan: '产品标语',
    feature: '中阀体可拆卸，维护便捷',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 20014,
    name: 'GQ41 加长颈球阀',
    picture: P20014,
    slogan: '产品标语',
    feature: '适用于保温管道',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 40002,
    name: '两阀组',
    picture: P40002,
    slogan: '产品标语',
    feature: '集成高压阀和低压阀，简化系统',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 10009,
    name: '21F 外螺纹截止阀',
    picture: P10009,
    slogan: '产品标语',
    feature: '安装快捷，兼容性强',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 10010,
    name: 'J211W 压力表截止阀',
    picture: P10010,
    slogan: '产品标语',
    feature: '精准控制压力表接入/切断',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 40003,
    name: '一体化三阀组',
    picture: P40003,
    slogan: '产品标语',
    feature: '减少泄漏点，提高可靠性',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 10011,
    name: 'J91 卡套截止阀',
    picture: P10011,
    slogan: '产品标语',
    feature: '适用于仪表管路，安装便捷',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 10012,
    name: 'J61Y 电站截止阀',
    picture: P10012,
    slogan: '产品标语',
    feature: '耐温达550℃，压力PN100以上',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 10013,
    name: 'J29 压力计专用截止阀',
    picture: P10013,
    slogan: '产品标语',
    feature: '直接连接压力计，方便检修',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 10014,
    name: 'J61Y型 高温高压截止阀',
    picture: P10014,
    slogan: '产品标语',
    feature: '耐高温高压（可达650℃）',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 10015,
    name: '槽罐车专用压力表截止阀',
    picture: P10015,
    slogan: '产品标语',
    feature: '适应槽罐车移动中的振动环境',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
    specialized: ['荆门宏图专用'],
  },
  {
    pid: 10016,
    name: 'JJM1 压力表截止阀',
    picture: P10016,
    slogan: '产品标语',
    feature: '适合空间受限的仪表安装',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 10017,
    name: 'J21W 外螺纹截止阀',
    picture: P10017,
    slogan: '产品标语',
    feature: '安装便捷，无需焊接',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 10018,
    name: 'SB02 手压泵专用截止阀',
    picture: P10018,
    slogan: '产品标语',
    feature: '专为手压泵系统优化',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 10019,
    name: 'J44F 槽罐车专用角式截止阀',
    picture: P10019,
    slogan: '产品标语',
    feature: '节省空间，适应槽罐车管路布局',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 10020,
    name: 'J63Y 对焊式截止阀',
    picture: P10020,
    slogan: '产品标语',
    feature: '高强度接口，无泄漏风险',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 10021,
    name: 'J43W 针形截止阀',
    picture: P10021,
    slogan: '产品标语',
    feature: '微调流量精准，适合仪表管路',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 10022,
    name: '切断阀 槽罐车专用双内螺纹角式截止阀',
    picture: P10022,
    slogan: '产品标语',
    feature: '双向连接，安装灵活',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 20015,
    name: 'Q21F 六角型外螺纹球阀',
    picture: P20015,
    slogan: '产品标语',
    feature: '便于工具拧紧，安装牢固',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 10023,
    name: 'J24W 一体式角式截止阀',
    picture: P10023,
    slogan: '产品标语',
    feature: '锻造一体化，减少渗漏点，提高安全性',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 10024,
    name: 'J14W 切断阀 槽罐车专用角式截止阀',
    picture: P10024,
    slogan: '产品标语',
    feature: '适应槽罐车复杂管路布局',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 10025,
    name: 'J13W 内螺纹截止阀',
    picture: P10025,
    slogan: '产品标语',
    feature: '结构紧凑，安装简便',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 30007,
    name: 'KSD-J49W-40P 槽罐车专用罐体取压阀',
    picture: P30007,
    slogan: '产品标语',
    feature: '专为槽罐车取压口设计',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
    specialized: ['荆门宏图专用', '中集瑞江专用'],
  },
  {
    pid: 20016,
    name: '快接式三片式球阀',
    picture: P20016,
    slogan: '产品标语',
    feature:
      '免拆阀体焊接，通过氦检，壁厚满足63-100公斤压力，全通径双四氟密封，采用大金及3M四氟',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 20017,
    name: '加长管型三片式球阀',
    picture: P20017,
    slogan: '产品标语',
    feature:
      '免拆阀体焊接，通过氦检，壁厚满足63-100公斤压力，全通径双四氟密封，采用大金及3M四氟',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
  {
    pid: 99999,
    name: '各式管路接头',
    picture: P99999,
    slogan: '产品标语',
    feature: '品类丰富，适用于多个行业和场景',
    link: 'https://item.jd.com/10143040307069.html',
    purchasable: false,
  },
]

export const industries = [
  {
    iid: 1,
    name: '槽罐车',
    picture: ind1,
    introduction:
      '凯士达通过为槽罐车行业提供高性能、定制化的阀门产品，在运输安全和效率方面发挥关键作用。我们的装卸阀、安全阀和紧急切断阀等产品，专为危化品、液化气体等介质设计，确保密封可靠、耐腐蚀，并能快速响应控制需求。',
    title: '凯士达槽罐车行业专业阀门解决方案',
    subtitle: '——专注危化品储运安全，定义行业高标准',
    document: [
      {
        style: 4,
        content:
          '在槽罐车运输领域，安全与可靠性是核心命脉。面对高压、强腐蚀介质、极端工况等严苛挑战，江苏凯士达阀门科技有限公司凭借深耕行业的技术积淀与智能化柔性生产能力，为全球客户提供高密封性、耐腐蚀、长寿命的专用阀门产品，助力危化品储运全程安全可控。',
      },
      {
        style: 2,
        content: '行业痛点与凯士达应对',
      },
      {
        style: 3,
        content: '痛点1：介质高危，泄漏风险大',
      },
      {
        style: 3,
        content: '→ 凯士达方案：',
      },
      {
        style: 4,
        content:
          '采用特种合金材质与多重密封结构设计，阀门耐压强度达50MPa以上，泄漏率低于0.001%，远超API 598标准，确保液化天然气、强酸强碱等介质的零泄漏运输。',
      },
      {
        style: 3,
        content: '痛点2：工况复杂，设备寿命短',
      },
      {
        style: 3,
        content: '→ 凯士达方案：',
      },
      {
        style: 4,
        content:
          '通过表面纳米涂层技术与抗振动结构优化，阀门耐腐蚀性能提升60%，适应极端工况。',
      },
      {
        style: 3,
        content: '痛点3：需求多样，交付周期长',
      },
      {
        style: 3,
        content: '→ 凯士达方案',
      },
      {
        style: 4,
        content:
          '依托柔性化智能生产线，支持小批量、多规格订单快速切换，交付周期缩短30%，满足客户紧急需求与定制化设计。',
      },
      {
        style: 2,
        content: '凯士达槽罐车阀门核心优势',
      },
      {
        style: 3,
        content: '专为危化品设计，安全至上',
      },
      {
        style: 4,
        content:
          '高压阀门系列：适用于LNG、液氨等高压介质，通过ISO认证，密封性能行业领先。',
      },
      {
        style: 4,
        content:
          '耐腐蚀阀门系列：针对硫酸、盐酸等强腐蚀介质，采用哈氏合金、双向不锈钢材质，耐蚀性远超行业标准。',
      },
      {
        style: 4,
        content:
          '紧急切断阀：配备智能传感与快速响应系统，泄漏或超压时0.5秒内自动切断，保障运输安全。',
      },
      {
        style: 3,
        content: '智能柔性生产，精准匹配需求',
      },
      {
        style: 4,
        content:
          '数字化设计：基于CFD流体仿真与AI算法，优化阀门流道结构，压损降低20%，流量效率提升15%。',
      },
      {
        style: 4,
        content:
          '高精度制造：全自动数控加工中心与机器人焊接工艺，确保关键尺寸精度达±0.01mm，产品一致性高。',
      },
      {
        style: 4,
        content:
          '敏捷交付：从图纸确认到成品出厂，全流程数字化管控，快速交付非标定制订单。',
      },
      {
        style: 3,
        content: '全生命周期服务，全程无忧',
      },
      {
        style: 4,
        content:
          '定制化方案：根据槽罐车型号、介质特性、管路布局等需求，提供选型、安装、测试一体化服务。',
      },
      {
        style: 2,
        content: '为何选择凯士达？',
      },
      {
        style: 4,
        content:
          '行业口碑：服务荆门宏图、中集瑞江等头部企业，产品覆盖多个国家和地区，故障率低于0.1%。',
      },
      {
        style: 4,
        content: '技术承诺：提供质保，终身技术支持，确保客户无后顾之忧。',
      },
      {
        style: 2,
        content: '凯士达使命：让危化品运输更安全、更高效',
      },
      {
        style: 4,
        content:
          '我们以“精工细作，安全可靠”为核心理念，持续推动槽罐车阀门技术的创新升级。未来，凯士达将深化AI智能诊断与危化品储运阀门研发，为行业提供更绿色、更智慧的解决方案。',
      },
    ],
  },
  {
    iid: 2,
    name: '氢能',
    picture: ind2,
    introduction:
      '凯士达通过研发高压、高密封性及耐氢脆的特种阀门产品，为氢能行业提供关键装备支持。我们的氢气专用阀门（如加氢站用高压切断阀、储氢罐阀门及输氢管道调节阀）采用先进材料和防泄漏设计，确保氢气在存储、运输及加注环节的安全高效流转。',
    title: '凯士达氢能行业阀门解决方案',
    subtitle: '——气动球阀 & 三片式球阀，革新科技赋能绿氢未来',
    document: [
      {
        style: 4,
        content:
          '在氢能产业链中，电解槽、储运系统及加氢环节对阀门的密封性、响应速度与耐久性要求极高。江苏凯士达阀门科技有限公司聚焦氢能核心场景，以气动球阀与三片式球阀为核心产品，通过技术革新与智能制造，为制氢、储运、加注等环节提供高可靠、高效率的阀门解决方案，助力客户突破高压、高纯、防泄漏的行业难题。',
      },
      {
        style: 2,
        content: '氢能阀门核心场景与凯士达创新突破',
      },
      {
        style: 4,
        content: '气动球阀：精准控制，快速响应',
      },
      {
        style: 4,
        content: '应用场景：电解槽氢气输出调节、加氢站流量控制。',
      },
      {
        style: 3,
        content: '技术优势：',
      },
      {
        style: 4,
        content:
          '智能驱动：集成高精度气动执行器，响应时间＜0.5秒，流量控制精度达±1%，适配动态制氢工况。',
      },
      {
        style: 4,
        content:
          '超纯介质适配：阀体内壁采用电解抛光工艺（Ra≤0.2μm），结合全金属密封，氢气纯度≥99.999%，金属离子析出量＜0.05ppb。',
      },
      {
        style: 4,
        content: '三片式球阀：免拆焊接，零泄漏革新',
      },
      {
        style: 4,
        content: '应用场景：氢气管路连接、储罐进出口控制。',
      },
      {
        style: 3,
        content: '技术革新：',
      },
      {
        style: 4,
        content:
          '免拆阀体焊接技术：独创一体化阀体结构与卡箍式密封设计，安装效率提升40%，避免传统焊接导致的变形与泄漏风险。',
      },
      {
        style: 4,
        content:
          '梯度密封系统：采用日本大金及3M四氟+金属缠绕垫片组合，动态密封泄漏率＜0.0005mL/min，达到ISO 15848-1最高等级（AH级）。',
      },
      {
        style: 4,
        content:
          '长寿命设计：阀杆与球体表面应用DLC类金刚石涂层，耐磨性提升3倍，启闭寿命超10万次。',
      },
      {
        style: 2,
        content: '凯士达使命：以革新科技，守护氢能安全',
      },
      {
        style: 4,
        content: '我们以“精工细作，安全可靠”为核心理念，持续深耕氢能阀门技术：',
      },
      {
        style: 4,
        content:
          '气动球阀：研发耐压70MPa超高压型号，适配下一代兆瓦级PEM电解槽。',
      },
      {
        style: 4,
        content:
          '三片式球阀：推动氢能管路“零焊接”标准化连接，引领行业安装革命。',
      },
    ],
  },
  {
    iid: 3,
    name: '半导体',
    picture: ind3,
    introduction:
      '凯士达为半导体行业提供超高纯、耐腐蚀的特种阀门产品，确保晶圆制造过程中气体和化学品的精确控制与零污染输送。',
    title: '凯士达半导体高纯气体阀门解决方案',
    subtitle: '——零污染、零泄漏，护航芯片制造极致纯净',
    document: [
      {
        style: 4,
        content:
          '在半导体制造领域，高纯气体是晶圆加工的核心“血液”，而阀门的性能直接决定气体纯度与系统可靠性。面对纳米级污染控制、超高洁净度、长周期稳定运行的严苛要求，江苏凯士达阀门科技有限公司以多年密封技术积淀与半导体级智造体系，为刻蚀、沉积、光刻等关键制程提供超高纯气体阀门，助力客户突破良率瓶颈，赋能先进制程升级。',
      },
      {
        style: 2,
        content: '半导体高纯气体阀门核心挑战与凯士达突破',
      },
      {
        style: 3,
        content: '挑战1：纳米级颗粒污染，良率骤降',
      },
      {
        style: 3,
        content: '→ 凯士达方案：',
      },
      {
        style: 4,
        content:
          '阀体内腔采用电解抛光+EP级清洗工艺，表面粗糙度Ra≤0.1μm，颗粒物控制达ISO 1级（≤0.1颗/ft³@0.1μm）。',
      },
      {
        style: 4,
        content:
          '全金属无死角设计，消除密封圈降解风险，金属离子析出量＜0.01ppb，满足28nm以下先进制程需求。',
      },
      {
        style: 3,
        content: '挑战2：超高纯气体泄漏，成本剧增',
      },
      {
        style: 3,
        content: '→ 凯士达方案：',
      },
      {
        style: 4,
        content:
          '独创双级弹性密封+自补偿结构，动态泄漏率＜1×10⁻⁹ atm·cc/s He，超越SEMI F78标准10倍。',
      },
      {
        style: 4,
        content: '氦质谱检漏全检，确保100%零泄漏交付。',
      },
      {
        style: 3,
        content: '挑战3：腐蚀性介质侵蚀，寿命不足',
      },
      {
        style: 3,
        content: '→ 凯士达方案：',
      },
      {
        style: 4,
        content:
          '可选用高镍合金C-22、316L VIM-VAR级不锈钢，耐Cl₂、HF等强腐蚀气体，硬度提升3倍，抗磨损性能行业领先。',
      },
      {
        style: 2,
        content: '凯士达半导体阀门技术优势',
      },
      {
        style: 3,
        content: '专为芯片制造定制，极致纯净',
      },
      {
        style: 4,
        content: '超高纯球阀：适配Ar、N₂、H₂等惰性气体，纯度维持≥99.99999%。',
      },
      {
        style: 4,
        content:
          '腐蚀性气体阀：针对WF₆、HCl等介质，采用双密封隔离腔设计，泄漏风险显著降低。',
      },
      {
        style: 4,
        content:
          '真空级隔膜阀：流道Cv值优化30%，真空度维持＜5×10⁻⁸ Torr，适配EUV光刻系统。',
      },
      {
        style: 3,
        content: '半导体级智造体系，精准可控',
      },
      {
        style: 4,
        content:
          '数字化工艺管控：关键参数实时监测，CPK值≥1.67，产品一致性达6σ水平。',
      },
      {
        style: 4,
        content:
          '敏捷交付能力：柔性产线支持DN6-DN60微型阀定制，交期短，响应半导体行业快速扩产需求。',
      },
      {
        style: 2,
        content: '凯士达愿景：以极致密封，定义芯片制造新标准',
      },
      {
        style: 4,
        content:
          '我们以“精工细作，安全可靠”为核心理念，持续加码EUV极紫外光刻阀门、原子层沉积（ALD）超微量控制阀等前沿技术研发，助力半导体产业向更精密、更高效、更可靠的方向迈进。',
      },
    ],
  },
  {
    iid: 4,
    name: '石油化工',
    picture: ind4,
    introduction:
      '凯士达为石油化工行业提供耐高压、耐腐蚀及抗爆的特种阀门产品，确保石油、天然气及各类化工介质的安全输送与精确控制。',
    title: '凯士达石油化工行业阀门解决方案',
    subtitle: '——耐压抗蚀，守护能源安全',
    document: [
      {
        style: 4,
        content:
          '在石油化工领域，阀门是保障生产安全与效率的核心枢纽。面对高压、强腐蚀、高粘度介质及极端温度、复杂工况的严苛挑战，江苏凯士达阀门科技有限公司依托多年石化行业深耕经验与智能化制造体系，为炼油、管道输送、催化裂化、储罐管理等环节提供高可靠性、长寿命的阀门产品，助力客户实现安全运营与降本增效。',
      },
      {
        style: 2,
        content: '石油化工阀门核心痛点与凯士达应对',
      },
      {
        style: 3,
        content: '痛点1：高压冲击，密封失效风险高',
      },
      {
        style: 3,
        content: '→ 凯士达方案：',
      },
      {
        style: 4,
        content:
          '采用多级金属硬密封技术与自适应预紧结构，阀门耐压等级达Class 2500（42MPa），动态密封泄漏率＜0.001mL/min，超越API 598标准。',
      },
      {
        style: 4,
        content: '锻钢一体式阀体，抗冲击强度提升50%，适配油气田井口高压工况。',
      },
      {
        style: 3,
        content: '痛点2：强腐蚀介质，设备寿命短',
      },
      {
        style: 3,
        content: '→ 凯士达方案：',
      },
      {
        style: 4,
        content:
          '针对硫化氢、酸性原油等介质，选用双相不锈钢2205、Incoloy 825特种材料，耐蚀性达NACE MR0175标准，使用寿命长。',
      },
      {
        style: 4,
        content:
          '热喷涂碳化钨涂层，硬度达HRC 70，耐磨性能提升3倍，应对含颗粒介质冲刷。',
      },
      {
        style: 3,
        content: '痛点3：工况复杂，维护成本高',
      },
      {
        style: 3,
        content: '→ 凯士达方案：',
      },
      {
        style: 4,
        content:
          '模块化设计：阀座、阀杆等关键部件可快速更换，维护时间缩短60%，降低停机损失。',
      },
      {
        style: 4,
        content:
          '智能监测系统：集成压力-温度传感器，实时传输数据至中控平台，故障预警准确率＞95%。',
      },
      {
        style: 2,
        content: '凯士达石油化工阀门技术优势',
      },
      {
        style: 3,
        content: '全场景覆盖，性能卓越',
      },
      {
        style: 3,
        content: '智造赋能，高效交付',
      },
      {
        style: 4,
        content:
          '数字孪生验证：通过FEA应力分析与CFD流场模拟，优化产品结构，故障率降低40%。',
      },
      {
        style: 4,
        content:
          '严苛质检体系：100%氦质谱检漏+72小时高压循环测试，确保零缺陷出厂。',
      },
      {
        style: 3,
        content: '全生命周期服务，全程无忧',
      },
      {
        style: 4,
        content:
          '定制化设计：根据介质特性、管路布局、操作频次等需求，提供选型-安装-调试一体化方案。',
      },
      {
        style: 2,
        content: '凯士达使命：以技术守护能源安全',
      },
      {
        style: 4,
        content:
          '我们以“精工细作，安全可靠”为核心理念，持续创新：推进智能阀门+数字孪生技术，赋能石化工厂智能化升级。',
      },
    ],
  },
  {
    iid: 5,
    name: '电力',
    picture: ind5,
    introduction:
      '凯士达为电力行业（包括火电、核电、新能源等）提供耐高温高压、抗冲刷的特种阀门解决方案，确保电站系统安全高效运行。',
    title: '凯士达电力行业阀门解决方案',
    subtitle: '——高可靠、智能化，赋能能源高效转化',
    document: [
      {
        style: 4,
        content:
          '在电力行业，阀门是保障发电机组安全运行与能效提升的关键设备。面对高温高压、频繁启停、强腐蚀介质等严苛工况，江苏凯士达阀门科技有限公司基于多年电力行业技术积淀与智能化柔性制造体系，为火电、核电、风电及新能源电站提供高密封性、长寿命、智能化的阀门产品，助力客户实现安全运营、效率提升与低碳转型。',
      },
      {
        style: 2,
        content: '电力行业核心挑战与凯士达应对',
      },
      {
        style: 3,
        content: '挑战1：超高温高压，密封失效风险高',
      },
      {
        style: 3,
        content: '→ 凯士达方案：',
      },
      {
        style: 4,
        content:
          '耐高温合金+金属硬密封：采用Inconel 718、F91锻钢材质，阀门耐温达650℃，耐压等级Class 4500（76MPa），适用于超超临界机组主蒸汽系统，泄漏率＜0.001mL/min，超越ASME B16.34标准。',
      },
      {
        style: 4,
        content:
          '抗热疲劳设计：通过FEA模拟优化结构，循环启闭寿命超10万次，适配燃机频繁调峰工况。',
      },
      {
        style: 3,
        content: '挑战2：介质腐蚀冲刷，设备寿命短',
      },
      {
        style: 3,
        content: '→ 凯士达方案：',
      },
      {
        style: 4,
        content:
          '特种涂层技术：阀内件表面应用碳化钨（WC）涂层与氮化钛（TiN）镀层，硬度达HRC 75，耐磨耐蚀性提升3倍，应对脱硫系统Cl⁻、SO₂腐蚀。',
      },
      {
        style: 4,
        content:
          '双相不锈钢阀门：针对海水冷却系统，选用UNS S32205材质，耐点蚀指数PREN≥40，寿命长。',
      },
      {
        style: 3,
        content: '挑战3：智能化升级需求迫切',
      },
      {
        style: 3,
        content: '→ 凯士达方案：',
      },
      {
        style: 4,
        content:
          '智能阀门+IoT集成：搭载压力、温度、振动多参数传感器，支持Modbus/PROFINET协议，实时数据接入电厂DCS系统，故障预警准确率＞98%。',
      },
      {
        style: 4,
        content:
          '数字孪生运维：通过远程诊断与寿命预测模型，维护成本降低30%，停机时间减少50%。',
      },
      {
        style: 2,
        content: '凯士达电力阀门技术优势',
      },
      {
        style: 3,
        content: '全场景覆盖，性能卓越',
      },
      {
        style: 4,
        content:
          '超临界机组调节阀：流量控制精度±0.5%，Cv值优化25%，助力煤耗降低3g/kWh。',
      },
      {
        style: 4,
        content:
          '风电耐腐蚀球阀：全通径设计，耐盐雾腐蚀超5000小时，适配海上风电塔筒液压系统。',
      },
      {
        style: 3,
        content: '智造赋能，高效交付',
      },
      {
        style: 4,
        content:
          '柔性生产线：配备五轴数控加工中心与自动化装配线，支持多规格定制。',
      },
      {
        style: 4,
        content:
          '严苛质检体系：100%氦检漏+48小时高温高压循环测试，确保零缺陷出厂，MTBF（平均无故障时间）久。',
      },
      {
        style: 4,
        content:
          '绿色工艺：采用低能耗加工与环保涂层技术，生产碳足迹减少20%，响应电力行业碳中和目标。',
      },
      {
        style: 3,
        content: '全生命周期服务，全程无忧',
      },
      {
        style: 4,
        content:
          '定制化设计：根据机组参数、介质特性、安装环境等需求，提供选型-仿真-安装一体化方案。',
      },
      {
        style: 2,
        content: '凯士达使命：以创新驱动电力未来',
      },
      {
        style: 4,
        content: '我们以“精工细作，安全可靠”为核心理念，持续引领技术革新：',
      },
      {
        style: 4,
        content: '研发700℃超高温阀门，突破下一代先进燃机技术瓶颈；',
      },
      {
        style: 4,
        content: '推动AI驱动的智能阀门集群，赋能智慧电厂建设。',
      },
    ],
  },
  {
    iid: 6,
    name: '水处理',
    picture: ind6,
    introduction:
      '凯士达为水处理行业提供耐腐蚀、抗污染及高密封性的专业阀门解决方案，确保市政供水、污水处理及工业水系统的可靠运行。',
    title: '凯士达水处理行业阀门解决方案',
    subtitle: '——智能耐腐，守护每一滴水的纯净与高效',
    document: [
      {
        style: 4,
        content:
          '在水处理领域，阀门是保障系统稳定运行与水质安全的核心枢纽。面对高腐蚀介质、复杂水质、频繁启停及严苛环保标准的挑战，江苏凯士达阀门科技有限公司依托多年流体控制技术积淀与绿色智造体系，为市政污水处理、工业循环水、海水淡化及饮用水系统提供高密封性、长寿命、智能化的阀门产品，助力客户实现高效运维、成本优化与可持续发展。',
      },
      {
        style: 2,
        content: '水处理行业核心痛点与凯士达应对',
      },
      {
        style: 3,
        content: '痛点1：介质强腐蚀，设备寿命短',
      },
      {
        style: 3,
        content: '→ 凯士达方案：',
      },
      {
        style: 4,
        content:
          '采用316L超低碳不锈钢、双相钢2205及哈氏合金C276材质，耐Cl⁻、SO₄²⁻等离子腐蚀，使用寿命长，超越ASTM G48标准。',
      },
      {
        style: 4,
        content:
          '等离子渗氮+环氧涂层双重防护，耐酸碱性能提升60%，适配污水处理厂强腐蚀工况。',
      },
      {
        style: 3,
        content: '痛点2：颗粒物磨损，密封失效风险高',
      },
      {
        style: 3,
        content: '→ 凯士达方案：',
      },
      {
        style: 4,
        content:
          '硬密封+自清洁流道设计：阀座表面碳化钨涂层硬度达HRC 70，耐颗粒冲刷能力提升3倍，动态泄漏率＜0.001mL/min。',
      },
      {
        style: 4,
        content: '全通径球阀：流阻趋零，避免泥沙沉积，适配高浊度原水处理场景。',
      },
      {
        style: 3,
        content: '痛点3：能效与环保要求升级',
      },
      {
        style: 3,
        content: '→ 凯士达方案：',
      },
      {
        style: 4,
        content:
          '智能调节阀：搭载电动/气动执行器，流量控制精度±1%，助力泵站节能15%-20%。',
      },
      {
        style: 2,
        content: '凯士达水处理阀门技术优势',
      },
      {
        style: 3,
        content: '全场景覆盖，性能卓越',
      },
      {
        style: 4,
        content:
          '污水专用刀闸阀：针对含纤维、污泥介质，采用锋刃式闸板设计，切断力提升50%，卡堵风险降低80%。',
      },
      {
        style: 4,
        content:
          '海水淡化蝶阀：超级双相钢阀体+EPDM密封圈，耐氯离子腐蚀指数PREN≥45，寿命突破20年。',
      },
      {
        style: 4,
        content:
          '饮用水隔膜阀：流道电解抛光（Ra≤0.4μm），通过3-A卫生认证，杜绝微生物滋生风险。',
      },
      {
        style: 3,
        content: '柔性智造，高效响应',
      },
      {
        style: 4,
        content:
          '数字化产线：配备机器人焊接单元与数控中心，支多规格定制，非标订单交付时间短。',
      },
      {
        style: 4,
        content:
          '模块化设计：阀座、密封件等组件可快速更换，维护时间缩短50%，降低综合运维成本。',
      },
      {
        style: 4,
        content:
          '严苛质检体系：100%氦检漏+5000次启闭寿命测试，故障率＜0.1%，MTBF（平均无故障时间）长。',
      },
      {
        style: 3,
        content: '智能运维，全程赋能',
      },
      {
        style: 4,
        content:
          '数字孪生优化：通过CFD模拟系统压损与流态，定制高效管路方案，能耗降低15%。',
      },
      {
        style: 4,
        content: '全球服务网络：紧急订单72小时交付，支持7×24小时远程诊断。',
      },
      {
        style: 2,
        content: '为何选择凯士达？',
      },
      {
        style: 4,
        content: '技术硬实力：拥有多项水处理阀门技术，产品通过ISO 9001认证。',
      },
      {
        style: 4,
        content:
          '行业深耕经验：服务多家头部企业，累计交付超5万台阀门，应用于100+市政/工业水处理项目。',
      },
      {
        style: 2,
        content: '凯士达使命：以创新科技，定义水资源未来',
      },
      {
        style: 4,
        content: '我们以“精工细作，安全可靠”为核心理念，持续推动技术升级：',
      },
      {
        style: 4,
        content: '研发纳米涂层耐腐阀门，突破高盐废水处理技术瓶颈；',
      },
      {
        style: 4,
        content: '布局AI驱动的智慧水务阀门集群，赋能水厂无人化运营。',
      },
    ],
  },
  {
    iid: 7,
    name: '冶金',
    picture: ind7,
    introduction:
      '凯士达为冶金行业提供耐高温、耐磨损及抗氧化的特种阀门解决方案，确保钢铁、有色金属等生产流程的稳定高效。',
    title: '凯士达冶金行业仪表阀解决方案',
    subtitle: '——耐高温、抗腐蚀，赋能冶金工业高效安全',
    document: [
      {
        style: 4,
        content:
          '在冶金行业，高温熔融金属、强腐蚀气体与粉尘、高频冲击等极端工况对仪表阀的耐高温性、密封可靠性及抗磨损性能提出了严苛要求。江苏凯士达阀门科技有限公司深耕冶金领域，以自主研发的高性能材料技术与智能化柔性制造体系为核心，为炼钢、连铸、轧制、烟气处理等关键环节提供高精度、长寿命的仪表阀产品，助力客户实现生产安全、效率提升与成本优化。',
      },
      {
        style: 2,
        content: '冶金行业核心挑战与凯士达应对',
      },
      {
        style: 3,
        content: '挑战1：高温熔融介质，阀门易变形失效',
      },
      {
        style: 3,
        content: '→ 凯士达方案：',
      },
      {
        style: 4,
        content:
          '超高温合金材质：采用Inconel 625、310S奥氏体不锈钢，耐温达1200℃，适配钢水包、中间包测温阀场景，使用寿命超5年。',
      },
      {
        style: 4,
        content:
          '水冷式阀体设计：集成循环冷却通道，表面温度降低至80℃以下，杜绝高温蠕变风险。',
      },
      {
        style: 3,
        content: '挑战2：粉尘与腐蚀性气体侵蚀，密封性能衰减',
      },
      {
        style: 3,
        content: '→ 凯士达方案：',
      },
      {
        style: 4,
        content:
          '硬密封+自清洁结构：阀座表面喷涂碳化钨涂层（硬度HRC 70），结合流道导流设计，耐粉尘冲刷性能提升3倍，动态泄漏率＜0.001mL/min。',
      },
      {
        style: 4,
        content:
          '耐酸蚀特种合金：针对SO₂、Cl₂等腐蚀气体，选用哈氏合金C276阀体，耐点蚀指数PREN≥68，寿命突破10年。',
      },
      {
        style: 3,
        content: '挑战3：高频振动与冲击，设备稳定性差',
      },
      {
        style: 3,
        content: '→ 凯士达方案：',
      },
      {
        style: 4,
        content:
          '抗冲击结构优化：通过FEA有限元分析强化阀杆与连接部件，抗振动等级达IEC 60068-2-6标准，适配轧机液压系统高频工况。',
      },
      {
        style: 4,
        content:
          '模块化快装设计：阀芯与密封组件可快速更换，维护时间缩短60%，降低停机损失。',
      },
      {
        style: 2,
        content: '凯士达冶金仪表阀技术优势',
      },
      {
        style: 3,
        content: '专为冶金定制，性能卓越',
      },
      {
        style: 4,
        content:
          '高温金属流量调节阀：耐温1100℃以上，流量控制精度±0.5%，适配电弧炉烟气回收系统，助力能效提升20%。',
      },
      {
        style: 4,
        content: '耐粉尘球阀：全通径设计，流阻趋零，避免高炉煤气粉尘沉积。',
      },
      {
        style: 4,
        content:
          '高压液压控制阀：耐压等级达42MPa，响应时间＜0.2秒，保障连铸机液压系统精准稳定。',
      },
      {
        style: 3,
        content: '智造赋能，高效交付',
      },
      {
        style: 4,
        content:
          '柔性生产线：配备数控中心与机器人焊接站，支持多规格定制，非标订单交付快。',
      },
      {
        style: 4,
        content:
          '数字化工艺管控：关键尺寸精度控制±0.01mm，产品一致性达6σ水平，通过ISO 认证。',
      },
      {
        style: 4,
        content:
          '严苛测试体系：100%高温氦检漏+10万次启闭寿命测试，故障率＜0.1%，MTBF（平均无故障时间）长。',
      },
      {
        style: 3,
        content: '全生命周期服务，全程护航',
      },
      {
        style: 4,
        content:
          '工况定制设计：根据介质温度、压力、颗粒物含量等参数，提供选型-仿真-安装一体化方案。',
      },
      {
        style: 2,
        content: '为何选择凯士达？',
      },
      {
        style: 4,
        content:
          '技术硬实力：拥有多项冶金阀门技术，耐高温与耐腐蚀性能对标国际一流品牌。',
      },
      {
        style: 4,
        content:
          '行业深耕案例：服务中冶、马来西亚联合钢铁等头部企业，产品应用于300+冶金项目。',
      },
      {
        style: 2,
        content: '凯士达使命：以创新科技，锻造冶金工业新标杆',
      },
      {
        style: 4,
        content: '我们以“精工细作，安全可靠”为核心理念，持续突破技术边界：',
      },
      {
        style: 4,
        content: '研发特种阀门，突破特种冶金极限工况；',
      },
      {
        style: 4,
        content: '推动AI驱动的预测性维护系统，赋能冶金工厂智能化升级。',
      },
    ],
  },
  {
    iid: 8,
    name: '食品与制药',
    picture: ind8,
    introduction:
      '凯士达为食品与制药行业提供符合卫生级认证（如FDA、EHEDG标准）的高洁净阀门产品，确保生产流程无污染、零死角。',
    title: '凯士达食品与制药行业仪表阀解决方案',
    subtitle: '——无菌级精密控制，守护每一份安全与纯净',
    document: [
      {
        style: 4,
        content:
          '在食品与制药领域，仪表阀是保障生产卫生安全与工艺精度的核心组件。面对无菌环境严苛要求、介质零污染风险、高频清洗耐受性等挑战，江苏凯士达阀门科技有限公司以为发酵、灌装、CIP清洗、纯化水系统等关键环节提供零死角、高洁净、长寿命的仪表阀产品，助力客户实现安全合规与高效生产。',
      },
      {
        style: 2,
        content: '行业核心痛点与凯士达突破',
      },
      {
        style: 3,
        content: '痛点1：微生物滋生与交叉污染风险',
      },
      {
        style: 3,
        content: '→ 凯士达方案：',
      },
      {
        style: 4,
        content:
          '无死角流道设计：阀体内腔采用全焊接抛光结构，圆角半径≤1.5D，表面粗糙度Ra≤0.4μm（电解抛光），杜绝残留与微生物附着。',
      },
      {
        style: 4,
        content:
          'FDA认证材质：选用316L超低碳不锈钢、EPDM/FKM食品级密封圈，耐酸碱与高温蒸汽清洗。',
      },
      {
        style: 3,
        content: '痛点2：介质纯度要求严苛，微量泄漏即报废',
      },
      {
        style: 3,
        content: '→ 凯士达方案：',
      },
      {
        style: 4,
        content:
          '双重弹性密封技术：动态泄漏率＜1×10⁻⁹ atm·cc/s He，超越ISO 15848-1最高标准（AH级），保障疫苗、注射液等高敏介质零污染。',
      },
      {
        style: 4,
        content:
          '在线灭菌适配性：阀门耐受132℃高温蒸汽循环灭菌，密封寿命超5000次，适配生物制药SIP（在位灭菌）工艺。',
      },
      {
        style: 3,
        content: '痛点3：验证复杂，合规成本高',
      },
      {
        style: 3,
        content: '→ 凯士达方案：',
      },
      {
        style: 4,
        content:
          '模块化快拆设计：阀芯与密封组件免工具拆卸，清洁验证时间缩短50%，降低合规成本。',
      },
      {
        style: 2,
        content: '凯士达卫生级仪表阀技术优势',
      },
      {
        style: 3,
        content: '专为洁净场景定制，极致安全',
      },
      {
        style: 4,
        content:
          '柔性交付能力：支持多规格定制，非标订单交付快，响应客户紧急扩产需求。',
      },
      {
        style: 3,
        content: '全生命周期服务，合规无忧',
      },
      {
        style: 4,
        content:
          '系统集成设计：基于CFD模拟优化管路布局，避免湍流死角，压损降低20%，能耗减少15%。',
      },
      {
        style: 2,
        content: '为何选择凯士达？',
      },
      {
        style: 4,
        content:
          '行业标杆合作：服务罗氏、药明康德、雅培、卡夫、达能等头部企业，产品应用于无菌灌装、生物反应器等高端产线。',
      },
      {
        style: 4,
        content: '零风险承诺：提供质保，48小时应急替换服务。',
      },
      {
        style: 2,
        content: '凯士达使命：以极致洁净，定义生命健康新标准',
      },
      {
        style: 4,
        content: '我们以“精工细作，安全可靠”为核心理念，持续创新：',
      },
      {
        style: 4,
        content:
          '研发超洁净纳米涂层阀门，突破细胞治疗与基因药物生产的技术壁垒；',
      },
      {
        style: 4,
        content:
          '布局AI驱动的智能洁净工厂解决方案，赋能行业无人化、零污染生产。',
      },
    ],
  },
  {
    iid: 9,
    name: '工业机械与设备',
    picture: ind9,
    introduction:
      '凯士达为工业机械与设备行业提供高可靠性、长寿命的专业阀门解决方案，确保各类机械设备液压、气动及流体控制系统的稳定运行。',
    title: '凯士达工业机械与设备行业仪表阀解决方案',
    subtitle: '——精密控制，赋能智造高效与可靠',
    document: [
      {
        style: 4,
        content:
          '在工业机械与设备领域，仪表阀是保障设备稳定运行与工艺精度的核心枢纽。面对高频振动、复杂介质、极端温压及小批量、多规格、快交付的严苛需求，江苏凯士达阀门科技有限公司依托多年流体控制技术积淀与智能化柔性制造体系，为工程机械、注塑成型、自动化产线、液压系统等场景提供高精度、长寿命、快速响应的仪表阀产品，助力客户实现设备效能提升、成本优化与智能化升级。',
      },
      {
        style: 2,
        content: '行业核心挑战与凯士达应对',
      },
      {
        style: 3,
        content: '挑战1：高频冲击与振动，密封易失效',
      },
      {
        style: 3,
        content: '→ 凯士达方案：',
      },
      {
        style: 4,
        content:
          '抗振结构设计：通过FEA有限元分析优化阀体与连接部件，适配工程机械液压系统10万次冲击工况。',
      },
      {
        style: 4,
        content:
          '自补偿密封技术：采用金属+PTFE复合密封圈，动态泄漏率＜0.001mL/min，振动环境下寿命提升3倍。',
      },
      {
        style: 3,
        content: '挑战2：介质多样，适配性要求高',
      },
      {
        style: 3,
        content: '→ 凯士达方案：',
      },
      {
        style: 4,
        content:
          '全材质覆盖：提供316L不锈钢、双相钢、钛合金等材质，耐压达42MPa，耐温-196℃~450℃，适配液压油、乳化液、切削液等介质。',
      },
      {
        style: 4,
        content:
          '模块化快换设计：阀芯、密封组件标准化，10分钟完成介质切换，维护效率提升60%。',
      },
      {
        style: 3,
        content: '挑战3：柔性生产与交付效率',
      },
      {
        style: 3,
        content: '→ 凯士达方案：',
      },
      {
        style: 4,
        content:
          '智能柔性产线：配备数控加工中心与机器人焊接站，支持多规格定制，非标订单交付快。',
      },
      {
        style: 4,
        content:
          '数字孪生验证：通过CFD流场仿真优化流道结构，压损降低25%，能耗减少18%。',
      },
      {
        style: 2,
        content: '凯士达仪表阀技术优势',
      },
      {
        style: 3,
        content: '专为工业机械定制，性能卓越',
      },
      {
        style: 4,
        content:
          '高压液压阀：耐压等级Class 6000（100MPa），响应时间＜0.1秒，适配盾构机、注塑机高压系统，泄漏率＜0.0001mL/min。',
      },
      {
        style: 4,
        content:
          '耐腐蚀调节阀：采用哈氏合金C276+碳化钨涂层，耐酸碱介质寿命超8万小时，适配电镀设备、化工机械。',
      },
      {
        style: 4,
        content:
          '微型精密阀：流量控制精度±0.3%，适配半导体设备、自动化机器人，关键尺寸公差±0.005mm。',
      },
      {
        style: 3,
        content: '智造赋能，敏捷响应',
      },
      {
        style: 4,
        content:
          '数字化全流程：从设计到生产全程MES系统管控，关键参数CPK≥1.67，产品一致性达6σ水平。',
      },
      {
        style: 4,
        content:
          '绿色高效工艺：采用低温冷焊与环保涂层技术，生产能耗降低30%，碳足迹减少25%。',
      },
      {
        style: 4,
        content:
          '严苛质检体系：100%氦质谱检漏+5万次寿命测试，故障率＜0.05%，MTBF（平均无故障时间）长。',
      },
      {
        style: 3,
        content: '全生命周期服务，全程无忧',
      },
      {
        style: 4,
        content:
          '工况定制方案：根据设备压力、介质、振动频率等参数，提供选型-仿真-安装一体化服务。',
      },
      {
        style: 4,
        content: '全球极速响应：紧急需求12小时响应，48小时交付。',
      },
      {
        style: 2,
        content: '凯士达使命：以创新科技，驱动工业智造未来',
      },
      {
        style: 4,
        content: '我们以“精工细作，安全可靠”为核心理念，持续突破技术边界：',
      },
      {
        style: 4,
        content:
          '研发智能自适应阀门，通过AI算法动态优化流量与压力，适配工业4.0柔性产线；',
      },
      {
        style: 4,
        content: '布局超高压微型化阀门，突破精密装备微型化技术瓶颈。',
      },
    ],
  },
]

export const customers = [
  {
    cid: 11,
    name: '槽罐车（荆门宏图专用）',
    pids: [30007, 10015, 10006, 30003, 10003, 10002],
  },
  {
    cid: 12,
    name: '槽罐车（中集瑞江专用）',
    pids: [30007, 30003],
  },
  {
    cid: 13,
    name: '槽罐车（楚胜汽车专用）',
    pids: [30003],
  },
  {
    cid: 14,
    name: '槽罐车（中集系统专用）',
    pids: [30003],
  },
  {
    cid: 15,
    name: '氢能',
    pids: [20013, 20016, 20017],
  },
  {
    cid: 16,
    name: '半导体',
    pids: [20013, 20016, 20017],
  },
]

export const varieties = [
  {
    vid: 101,
    name: '截止阀',
    pids: [
      10001, 10004, 10005, 10006, 10007, 10008, 10009, 10010, 10011, 10012,
      10013, 10014, 10015, 10016, 10017, 10018, 10019, 10020, 10021, 10022,
      10023, 10024, 10025, 10002, 10003,
    ],
    trimmed: true,
  },
  {
    vid: 102,
    name: '球阀',
    pids: [
      20001, 20002, 20003, 20004, 20005, 20006, 20007, 20008, 20009, 20010,
      20011, 20012, 20013, 20014, 20015, 20016, 20017,
    ],
    trimmed: true,
  },
  {
    vid: 103,
    name: '其他阀门',
    pids: [30001, 30002, 30004, 30005, 30006, 30007, 30003],
    trimmed: true,
  },
  {
    vid: 104,
    name: '阀组',
    pids: [40001, 40002, 40003],
    trimmed: false,
  },
  {
    vid: 105,
    name: '非阀门产品',
    pids: [99999, 50001, 50002],
    trimmed: false,
  },
]

const mainThemePids = [10005, 10001, 10008, 30005, 30007]

const subThemePids = [10006, 10009, 10010, 10011]

export const getProductByPid = (pid) => {
  for (var product of products) {
    if (product.pid == pid) {
      return product
    }
  }
}

export const getIndustryByIid = (iid) => {
  for (var industry of industries) {
    if (industry.iid == iid) {
      return industry
    }
  }
}

export const getVarietyByVid = (vid) => {
  for (var variety of varieties) {
    if (variety.vid == vid) {
      return variety
    }
  }
  return null
}

export const getMainThemeProducts = () => {
  const result = []
  for (var pid of mainThemePids) {
    for (var product of products) {
      if (product.pid == pid) {
        result.push(product)
        break
      }
    }
  }
  return result
}

export const getSubThemeProducts = () => {
  const result = []
  for (var pid of subThemePids) {
    for (var product of products) {
      if (product.pid == pid) {
        result.push(product)
        break
      }
    }
  }
  return result
}

export const getProductsOfIndustry = (iid) => {
  const result = []
  for (var industry of industries) {
    if (industry.iid == iid) {
      for (var pid of industry.pids) {
        for (var product of products) {
          if (product.pid == pid) {
            result.push(product)
            break
          }
        }
      }
      break
    }
  }
  return result
}

export const getProductsOfCustomer = (cid) => {
  const result = []
  for (var customer of customers) {
    if (customer.cid == cid) {
      for (var pid of customer.pids) {
        for (var product of products) {
          if (product.pid == pid) {
            result.push(product)
            break
          }
        }
      }
      break
    }
  }
  return result
}

export const getProductsOfVariety = (vid, limit) => {
  const result = []
  for (var variety of varieties) {
    if (variety.vid == vid) {
      if (limit <= 0) {
        for (var pid of variety.pids) {
          for (var product of products) {
            if (product.pid == pid) {
              result.push(product)
              break
            }
          }
        }
      } else {
        var n = Math.min(limit, variety.pids.length)
        for (var i = 0; i < n; i++) {
          for (var product of products) {
            if (product.pid == variety.pids[i]) {
              result.push(product)
              break
            }
          }
        }
      }
      break
    }
  }
  return result
}
